// @flow

import { EventEmitter } from 'event-emitter';

export default class Service extends EventEmitter {}
